<template lang="pug">
AppForm(
  :initialValues="transferee"
  :formValidations="formValidations"
  @submit="onFormSubmit"
)
  LoadingArea(:loading="isLoading" position="top")
    .card-container.flex-col
      .flex.justify-between
        .my-1.text-xl
          span(v-if="transferee.id") Edit Transferee
          span(v-else) New Transferee
        .flex-end.gap-4.justify-end
          Button(v-if="transferee.id" @click="cancelForm" label="Cancel" size="small" severity="secondary" icon="ph ph-caret-double-left" rounded)
          Button(type="submit" :label="buttonLabel" size="small" icon="ph ph-caret-double-right" iconPos="right" rounded)

      .grid.grid-cols-2.gap-4
        //------------------------
        //- LEFT COLUMN
        //------------------------
        .flex-1
          .card
            .card-header.font-bold.mb-0 Name / Contact Info
            .grid.grid-cols-2.gap-6
              .field
                AppTextInput(name="firstName" label="First Name *")
              .field
                AppTextInput(name="lastName" label="Last name *")
            .grid.grid-cols-2.gap-6
              .field
                AppDropdown(name="category" label="Category *" :options="transfereeCategoryOptions" optionValue="name")
              .field
                AppDropdown(name="transfereeStatusId" label="Status" :options="dropdownOptions.transfereeStatusesOptions")

            hr.mt-5
            
            .grid.grid-cols-2.gap-6
              .field
                AppTextInput(name="phone1" label="Phone") 
              .field
                AppTextInput(name="email" label="Email")
            .grid.grid-cols-2.gap-6
              .field
                AppTextInput(name="phone2" label="Phone 2")
              .field
                AppTextInput(name="emailTwo" label="Email 2")

            hr.mt-5
            
            .grid.grid-cols-1.gap-6
              .field
                AppTextInput(name="currentAddress" label="Current address")
            .grid.grid-cols-12.gap-6
              .field.col-span-6
                AppTextInput(name="currentCity" label="City")
              .field.col-span-2
                GeoStateDropdown(name="stateCode" label="State")
              .field.col-span-2
                AppTextInput(name="currentZip" label="Zip")
              .field.col-span-2
                CountryDropdown(name="countryCode" label="Country")       
          .card
            .card-header.font-bold.mb-0 Personal
            .grid.grid-cols-2.gap-6
              .field
                AppToggleInput.ml-2(name="purchaser" label="Purchaser")
              .field
                AppToggleInput.ml-2(name="renter" label="Renter")
            .grid.grid-cols-2.gap-6
              .field
                AppDropdown(name="citizenshipId" label="Citizenship" :options="dropdownOptions.citizenshipsOptions")
              .field
                AppDropdown(name="maritalStatusId" label="Marital status" :options="dropdownOptions.maritalStatusesOptions")
            
            hr.mt-5

            .grid.grid-cols-3.gap-6
              .field
                AppCurrencyInput(name="salary" label="Salary ($)") 
              .field
                AppCurrencyInput(name="salaryHigh" label="Salary High ($)")
              .field
                AppCurrencyInput(name="actualLeaseAmount" label="Actual Lease Amt")

            hr.mt-5

            .grid.grid-cols-2.gap-6
              .field
                AppTextInput(name="partnerFirstName" label="Partner first name")
              .field
                AppTextInput(name="partnerLastName" label="Partner last name")
            .grid.grid-cols-2.gap-6
              .field
                AppTextInput(name="partnerPhone" label="Partner phone")
              .field
                AppTextInput(name="partnerEmail" label="Partner email")

            hr.mt-5      
            
            .grid.grid-cols-2.gap-6
              .field
                AppNumberInput(name="numChildren" label="Num children")
              .field
                AppTextInput(name="roommateNotes" label="Roommate notes")
            .grid.grid-cols-1.gap-6      
              .field
                AppTextareaInput(name="childrenNotes" label="Children notes" rows="4")

            hr.mt-5

            .grid.grid-cols-12.gap-6
              .field.col-span-3
                AppNumberInput(name="numDogs" label="Num dogs")
              .field.col-span-3
                AppNumberInput(name="numCats" label="Num cats") 
              .field.col-span-6
                AppTextInput(name="petNotes" label="Pet notes")
          .card
            .card-header.font-bold.mb-0 Requirements
            .grid.grid-cols-4.gap-6
              .field
                AppNumberInput.text-center(name="numBeds" label="Beds (low)") 
              .field
                AppNumberInput.text-center(name="numBedsHigh" label="Beds (high)")
              .field
                AppNumberInput.text-center(name="numBaths" label="Baths")
              .field
                AppNumberInput.text-center(name="sqft" label="SQFT Min")
            .grid.grid-cols-2.gap-6
              .field
                AppCurrencyInput(name="priceRangeLow" label="Price Range Low ($)")
              .field
                AppCurrencyInput(name="priceRangeHigh" label="Price Range High ($)") 
            .grid.grid-cols-1.gap-6
              .field
                AppTextInput(name="commuteTime" label="Commute time")
            .grid.grid-cols-1.gap-6
              .field
                AppTextareaInput(name="specialConcerns" label="Requirements Details" rows="4")  
            .grid.grid-cols-1.gap-6
              .field
                AppTextareaInput(name="specialInterests" label="Other concerns/interests" rows="4")
            .grid.grid-cols-1.gap-6
              .field
                AppTextareaInput(name="preferredAreas" label="Preferred areas" rows="4")  
            .grid.grid-cols-1.gap-6
              .field
                AppTextareaInput(name="tourFeedback" label="Tour feedback" rows="4")

        //------------------------
        //- RIGHT COLUMN
        //------------------------
        .flex-1  
          .card
            .card-header.font-bold.mb-0 Company / Staffing          
            .grid.grid-cols-2.gap-6
              .field
                AppDropdown(name="companyId" label="Company" :options="dropdownOptions.companiesOptions" filter)
              .field
                AppDropdown(name="hrContactId" label="HR contact" :options="dropdownOptions.hrContactsOptions" filter)
            
            hr.mt-5
            
            .grid.grid-cols-2.gap-6
              .field
                AppDropdown(name="reloCompanyId" label="Relo company" :options="dropdownOptions.reloCompaniesOptions" filter)
              .field
                AppDropdown(name="reloConsultantId" label="Relo consultant" :options="dropdownOptions.reloConsultantsOptions" filter)
            .grid.grid-cols-2.gap-6                  
              .field
                AppDropdown(name="reloAssociateId" label="Relo associate" :options="dropdownOptions.reloConsultantsOptions" filter)
            
            hr.mt-5

            .grid.grid-cols-1.gap-6
              .field
                CounselorDropdown(name="destinationCounselorId" label="Destination counselor")

          .card
            .card-header.font-bold.mb-0 Dates
            .grid.grid-cols-2.gap-6
              .field
                AppDateInput(name="initiationDate" label="Initiation date *")                 
              .field
                AppDateInput(name="interviewDate" label="Interview date")
            .grid.grid-cols-2.gap-6
              .field
                AppDateInput(name="arrivalDate" label="Arrival date")
              .field
                AppDateInput(name="departureDate" label="Departure date")

            hr.mt-5

            .grid.grid-cols-2.gap-6
              .field
                AppDateInput(name="moveInDate" label="Corporate Housing Move In")
              .field
                AppDateInput(name="moveOutDate" label="Corporate Housing Move Out")
            .grid.grid-cols-2.gap-6
              .field
                AppDateInput(name="startWorkDate" label="Start work date")
              .field
                AppDateInput(name="leaseStartDate" label="Est. Lease Start")
            .grid.grid-cols-2.gap-6
              .field
                AppDateInput(name="websiteSentDate" label="Website sent")
              .field

          .card
            .card-header.font-bold.mb-0 Authorized Services
            .grid.grid-cols-16.gap-6
              .field.col-span-4
                AppToggleInput.ml-2(name="multiDay" label="Multi-day?")
              .field.col-span-6
                AppCurrencyInput(name="billingLimit" label="Billing Limit ($)") 
              .field.col-span-6
                AppTextInput(name="fileNumber" label="Billing / File #")

            hr.mt-5

            .grid.grid-cols-2.gap-6
              .field
                AppDropdown(name="zoneId" label="Destination" :options="dropdownOptions.zonesOptions")
            .grid.grid-cols-1.gap-6
              .field
                AppTextareaInput(name="destinationNotes" label="Destination notes" rows="4")

            hr.mt-5

            .grid.grid-cols-2.gap-6
              .field
                AppDropdown(name="authorizedDays" label="Days authorized" :options="dropdownOptions.authorizedDaysOptions")
            .grid.grid-cols-1.gap-6        
              .field
                AppTextareaInput(name="authorizationNotes" label="Authorization notes" rows="4")
          .card
            .card-header.font-bold.mb-0 Other
            .grid.grid-cols-1.gap-6
              .field
                AppDropdown(name="hotelId" label="Hotel / Corporate Housing" :options="dropdownOptions.hotelsOptions" filter)

          .card(v-if="!transferee.id")
            .card-header.font-bold.mb-0 Save Options:
            .flex.items-center.gap-2
              ToggleSwitch(v-model="createFirstContactTodo")
              span.text-sm Create First Contact Todo

      .card
        .flex-between.mt-1.mx-3
          div
            Button(v-if="isAdmin && transferee.id" @click="toggleDeletePopup" v-tooltip="'Delete this Transferee'" icon="ph ph-trash" size="small" severity="danger" rounded)
          .flex.gap-3
            Button(v-if="transferee.id" @click="cancelForm" label="Cancel" size="small" severity="secondary" icon="ph ph-caret-double-left" rounded)
            Button(type="submit" :label="buttonLabel" size="small" icon="ph ph-caret-double-right" iconPos="right" rounded)


  //- .grid.grid-cols-3.gap-4
    pre appForm: {{ appForm }}
    //- pre appForm.errors: {{ appForm.errors }}
    //- pre formRef?.fields: {{ formRef?.fields }}
    //- pre formRef?.states: {{ formRef?.states }}

  //- Popup Dialog - Delete Transferee
  Dialog(v-if="isAdmin && transferee.id" v-model:visible="popup.visible" modal :dismissableMask="true" :header="`Delete Transferee — ${transferee.name}?`" position="center" :style="{ width: '52rem' }")
    LoadingArea.mx-5(:loading="popup.isLoading")
      .bg-orange-100.py-4.px-6.rounded-lg.italic
        .text-orange-600.font-semibold Important
        p.text-orange-600.my-2 If you delete this transferee then all associated records will also be deleted. 
        p.text-orange-600.my-2 For example - all Documents, Todos, Comments, Tours, Tour Comments, Timesheets and FollowUps, etc. will also be permanently removed.

      p.my-5 Summary of associated records that will be deleted if this Transferee is removed
      table.table
        tr.bg-canvas-800.text-canvas-100.font-semibold
          td Transferee
          td {{ transferee.name }}
        tr.bg-canvas-200
          th Record Type
          th Record Count
        tr(:class="{'bg-canvas-100 text-canvas-400': associatedRecords.toursCount==0}")
          td Tours
          td.font-semibold {{ associatedRecords.toursCount }}
        tr(:class="{'bg-canvas-100 text-canvas-400': associatedRecords.timesheetsCount==0}")
          td Timesheets
          td.font-semibold {{ associatedRecords.timesheetsCount }}
        tr(:class="{'bg-canvas-100 text-canvas-400': associatedRecords.followUpsCount==0}")
          td FollowUps
          td.font-semibold {{ associatedRecords.followUpsCount }}
        tr(:class="{'bg-canvas-100 text-canvas-400': associatedRecords.documentsCount==0}")
          td Documents
          td.font-semibold {{ associatedRecords.documentsCount }}
        tr(:class="{'bg-canvas-100 text-canvas-400': associatedRecords.todosCount==0}")
          td Todos
          td.font-semibold {{ associatedRecords.todosCount }}
        tr(:class="{'bg-canvas-100 text-canvas-400': associatedRecords.commentsCount==0}")
          td Comments
          td.font-semibold {{ associatedRecords.commentsCount }}

      hr.my-7
      .field
        label.label Enter your First and Last Name to verify this deletion
        InputText(v-model="userName" fluid required placeholder="First Name Last Name")
        Message.mt-2(v-if="!isDeleteEnabled" severity="error" size="small" variant="simple") To continue, please enter your full user name: {{ currentUser.fullName }}

    template("#footer")
      Button(@click="toggleDeletePopup" label="Cancel" size="small" severity="secondary" :disabled="popup.isLoading")
      Button(@click="handleDelete" label="Delete Transferee" size="small" severity="danger" :disabled="!isDeleteEnabled || popup.isLoading")
</template>

<script setup>
import { ref, reactive, computed, watch, onMounted } from 'vue'
import { useRouter }  from 'vue-router';
import Dialog         from 'primevue/dialog'
import { useAuthStore }  from '@/stores'

import { yup } from '@/use'
import { utils, pageSuccess } from '@/utils'
import { transfereeApi } from '@/api'
import { transfereeCategoryOptions } from '@/lib/constants'


const props = defineProps({
  transferee: { type: Object, default: {} },
})

const emit = defineEmits(['cancel', 'save'])

const router = useRouter()
const userName = ref()
const { currentUser } = useAuthStore();

const popup = reactive({
  isLoading: false,
  visible:    false,
  transferee: props.transferee,
})

const associatedRecords = ref({})

const formValidations = {
    firstName: yup
      .string()
      .required('first name is required')
      .max(50, 'first name must be no more than 50 characters'),
    lastName: yup
      .string()
      .required('last name is required')
      .max(50, 'last name must be no more than 50 characters'),
    category: yup
      .string()
      .required('category is required')
      .oneOf(transfereeCategoryOptions.map((cate) => cate.name), 'Please select category from the list'),
    initiationDate: yup
      .date()
      .required('initiation date is required'),
    zoneId: yup
      .number()
      .required('zone is required'),
    petNotes: yup
      .string()
      .nullable()
      .max(2000, 'pet notes must be no more than 2000 characters'),
    childrenNotes: yup
      .string()
      .nullable()
      .max(500, 'children notes must be no more than 500 characters'),
    specialConcerns: yup
      .string()
      .nullable()
      .max(1000, 'special concerns must be no more than 1000 characters'),
    preferredAreas:  yup
      .string()
      .nullable()
      .max(1000, 'preferred areas must be no more than 1000 characters'),
    currentAddress: yup
      .string()
      .nullable()
      .max(100, 'current address must be no more than 100 characters'),
    commuteTime: yup
      .string()
      .nullable()
      .max(100, 'commute time must be no more than 100 characters'),
    email: yup
      .string()
      .nullable()
      .max(50, 'email must be no more than 50 characters'),
    emailTwo: yup
      .string()
      .nullable()
      .max(50, 'email_2 time must be no more than 50 characters'),
    currentCity: yup
      .string()
      .nullable()
      .max(50, 'city must be no more than 50 characters'),
    partnerFirstName: yup
      .string()
      .nullable()
      .max(50, 'partner first name must be no more than 50 characters'),
    partnerLastName: yup
      .string()
      .nullable()
      .max(50, 'partner last name must be no more than 50 characters'),
    partnerEmail: yup
      .string()
      .nullable()
      .max(50, 'partner email must be no more than 50 characters'),
    phone1: yup
      .string()
      .nullable()
      .max(25, 'phone1 must be no more than 25 characters'),
    phone2: yup
      .string()
      .nullable()
      .max(25, 'phone2 must be no more than 25 characters'),
    partnerPhone: yup
      .string()
      .nullable()
      .max(25, 'partner phone must be no more than 25 characters'),
    fileNumber: yup
      .string()
      .nullable()
      .max(25, 'file number must be no more than 25 characters'),
    stateCode: yup
      .string()
      .max(15, 'state code must be no more than 15 characters')
      .nullable()
      .test("state-or-country", "Please fill in either \"state or country\", but not both", function(stateCode) {
        const { countryCode } = this.parent;

        if (!stateCode && !countryCode) {
          return false
        }

        if (!!stateCode && !!countryCode) {
          return false
        }

        return true
      }),      
    countryCode: yup
      .string()
      .max(15, 'country code must be no more than 15 characters')
      .nullable()
      .test("country-or-state", "Please fill in either \"state or country\", but not both", function(countryCode) {
        const { stateCode } = this.parent;

        if (!stateCode && !countryCode) {
          return false
        }

        if (!!stateCode && !!countryCode) {
          return false
        }

        return true
      }),
    currentZip: yup
      .string()
      .nullable()
      .max(15, 'zip must be no more than 15 characters'),
    priceRangeLow: yup
      .number()
      .nullable()
      .min(0.01, 'price range low must be greater than or equal to 0.01'),
    priceRangeHigh: yup
      .number()
      .nullable()
      .min(0.01, 'price range high must be greater than or equal to 0.01'),
    salary: yup
      .number()
      .nullable()
      .min(0.01, 'salary low must be greater than or equal to 0.01'),
    salaryHigh: yup
      .number()
      .nullable()
      .min(0.01, 'salary high must be greater than or equal to 0.01'),
    numChildren: yup
      .number()
      .nullable()
      .min(0, 'num children must be greater than or equal to 0'),
    numCats: yup
      .number()
      .nullable()
      .min(0, 'num cats must be greater than or equal to 0'),
    numDogs: yup
      .number()
      .nullable()
      .min(0, 'num dogs must be greater than or equal to 0'),
    numBeds: yup
      .number()
      .nullable()
      .min(0, 'num beds must be greater than or equal to 0')
      .max(255, 'num beds must be less than or equal to 255'),
    numBaths: yup
      .number()
      .nullable()
      .min(0, 'num baths must be greater than or equal to 0')
      .max(255, 'num baths must be less than or equal to 255'),
    numBedsHigh: yup
      .number()
      .nullable()
      .min(0, 'num beds high must be greater than or equal to 0')
      .max(255, 'num beds high must be less than or equal to 255'),
    sqft: yup
      .number()
      .nullable()
      .min(0, 'sqft must be greater than or equal to 0'),
}

const isLoading = ref(false)
const createFirstContactTodo = ref(true)

const dropdownOptions = ref({
  hotelsOptions: [],
  companiesOptions: [],
  hrContactsOptions: [],
  reloCompaniesOptions: [],
  reloConsultantsOptions: [],
  transfereeStatusesOptions: [],
  citizenshipsOptions: [],
  maritalStatusesOptions: [],
  zonesOptions: [],
  authorizedDaysOptions: [],  
})

const isAdmin = computed(() => {
  return currentUser.isAdmin
})

const buttonLabel = computed(() => {
  return props.transferee.id ? 'Update Transferee' : 'Create Transferee'
})

const onFormSubmit = ({valid, values}) => {
  // console.log('onFormSubmit', valid, values)
  if (valid) {
    isLoading.value = true

    if (props.transferee.id) {
      transfereeApi.update(props.transferee.id, {transferee: values})
        .then(response => {
          emit('save', response)
          pageSuccess(response)
        }).finally(() => isLoading.value = false)
    } else {
      transfereeApi.create({transferee: values, createFirstContactTodo: createFirstContactTodo.value})
        .then(response => {
          emit('save', response)
          pageSuccess(response)
        }).finally(() => isLoading.value = false)
    }
  }
}

const cancelForm = () => {
  emit('cancel')
}

const toggleDeletePopup = () => {
  popup.visible = !popup.visible
}

const isDeleteEnabled = computed(() => {
  return userName.value && userName.value.toLowerCase() == currentUser.fullName.toLowerCase()
})

const handleDelete = () => {
  if (isDeleteEnabled.value) {
    popup.isLoading = true

    transfereeApi
      .delete(props.transferee.id)
      .then(response => {
        router.push('/').then(() => {
          pageSuccess(response)
        });
      }).finally(() => popup.isLoading = false)
  } else {
    console.log('Please enter correct user name')
    // Show error message
  }
}

const confirmMessage = computed(() => {
  return `Are you sure you want to delete transferee "${props.transferee.name}"`
})

onMounted(() => {
  isLoading.value = true

  const fetchDropdownOptions = transfereeApi
    .getDropdownOptions(props.transferee.id)
    .then(response => { dropdownOptions.value = response.data })

  if (props.transferee.id) {
    const fetchAssociatedRecords = transfereeApi
      .getAssociatedRecords(props.transferee.id)
      .then(response => { associatedRecords.value = response.data })

    Promise.all([fetchDropdownOptions, fetchAssociatedRecords]).finally(() => {
      isLoading.value = false
    })
  } else {
    fetchDropdownOptions.finally(() => {
      isLoading.value = false
    })
  }
})
</script>